import type { FC } from 'react';
import type { ChipProps } from '@/ui/Chip/types';
import { Flex, Skeleton, Typography } from '@ui';
import clsx from 'clsx';
import styles from './Chip.module.css';

type Subcomponents = {
    Skeleton: FC;
};

const Chip: FC<ChipProps> & Subcomponents = ({ children, variant = 'default', ...props }) => (
    <Flex justify="center" align="center" className={clsx(styles.chip, styles[`variant-${variant}`])} {...props}>
        <Typography.Paragraph>{children}</Typography.Paragraph>
        {variant === 'danger' && (
            <svg width={20} height={18} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.icon}>
                <path opacity="0.5" d="M22 2L2 20M2 2L22 20" stroke="currentColor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            </svg>
        )}
    </Flex>
);

Chip.Skeleton = () => (
    <Skeleton width={64} height={32} />
);

export { Chip };
